<!--<app-loading-component *ngIf="isShowLoadingComponent"></app-loading-component>-->
<div  class="common-back-btn-sight"  (click)="close();" id="closeBtn" style="top:.2rem">
  <span>×</span>
</div>

<div id='video'></div>

<div id="shade"></div>

<div id="tip1" class="tip">
  <p class="fontSize16 lineHeight21">课程还未完成，确认要退出吗？</p>

  <button id="quitBtn" class="btnWord" (click)="exit();">退出</button>
  <button id="continueBtn" class="btnWord" (click)="continue();">继续</button>
</div>

<img src="{{assetsRoute}}/picture/courselearning/test.jpeg" alt="" id="picture">

<!--<div id="savePic" class="fontSize16">
    长按保存图片并分享
    <span class="fontSize14" (click)="goToQuestion()">关闭</span>
</div>-->



// WEBPACK FOOTER //
// ./src/app/course-learning-main/course-learning-main.component.html